{
  "language": {
    "label": "Language",
    "names": {
      "bg": "Български",
      "en": "English"
    }
  },
  "theme": {
    "label": "Appearance",
    "names": {
      "system": "System",
      "light": "Light",
      "dark": "Dark"
    }
  },
  "errors": {
    "auth": {
      "confirmation_invalid": "That confirmation link is invalid or has expired.",
      "email_taken": "That email address is already registered.",
      "external_signup_failed": "An account could not be created from that sign-in.",
      "failed": "Sign-in failed. Please try again.",
      "firebase_not_configured": "Sign-in by code through Firebase is not set up here.",
      "invalid_credentials": "Email or password is incorrect",
      "last_credential": "This is the only way you can sign in, so it cannot be removed.",
      "link_failed": "That sign-in method could not be linked to your account.",
      "otp_invalid": "That code is wrong or has expired.",
      "otp_rate_limited": "Too many codes requested. Wait a few minutes and try again.",
      "otp_daily_limit": "No more sign-in codes can be sent today. Try again tomorrow, or call us to book.",
      "otp_signup_failed": "An account could not be created for that number.",
      "refresh_token_expired": "Your session expired. Please sign in again.",
      "refresh_token_invalid": "Your session is no longer valid. Please sign in again.",
      "refresh_token_reused": "Your session was ended as a precaution. Please sign in again.",
      "refresh_token_wrong_tenant": "That session belongs to a different company.",
      "reset_token_invalid": "That reset link is invalid or has expired.",
      "session_expired": "Your session expired. Please sign in again.",
      "unauthenticated": "Sign-in required"
    },
    "tenant": {
      "not_resolved": "Unknown company",
      "not_found": "Unknown company",
      "slug_taken": "That company code is already taken",
      "inbound_number_taken": "Another company already receives calls on that number",
      "host_taken": "Another company already answers on that address"
    },
    "dispatch": {
      "driver_unavailable": "That driver is not available",
      "driver_on_another_order": "That driver is already on order {{reference}}",
      "order_finished": "That order has already finished",
      "no_open_assignment": "That driver is not holding this order",
      "driver_cannot_cancel": "Only the office can call off a ride it gave you"
    },
    "telephony": {
      "pbx_unavailable": "The telephone system is not answering.",
      "pbx_unauthorised": "The telephone system refused these credentials.",
      "call_not_controllable": "That call is no longer yours to change.",
      "not_enabled": "This company has no telephone system set up.",
      "no_extension": "You have no telephone yet. Reload the console to be given one.",
      "realtime_unavailable": "The telephone system's extension database is not answering.",
      "recording_disabled": "This company does not record calls.",
      "recording_unavailable": "That recording is no longer available.",
      "all_lines_busy": "Every line outgoing calls leave on is busy. Try again in a moment.",
      "no_outbound_lines": "None of the lines outgoing calls leave on exists any more. Choose them again in the telephony settings.",
      "call_flow_not_enabled": "This company's call flow does not park callers.",
      "hold_lines_full": "Every line that may hold a caller is already holding one ({{held}} of {{max}}). Tell the caller you will ring back.",
      "no_desk_phone_extension": "Every desk phone number from 7500 to 7999 has been used.",
      "no_telephone": "None of your telephones can be reached right now. Check the desk phone is plugged in, or open the console telephone.",
      "desks_belong_to_dispatchers": "Desk phones here belong to dispatchers. Your administrator gives you yours.",
      "mac_taken": "Another desk phone already has that MAC address, here or at another company.",
      "desk_has_phones": "The desk still has phones on it. Move them to another desk or remove them first.",
      "line_name_taken": "The telephone system already has a line of that name in its own configuration. Leave the password empty to list it as it is, or choose another name."
    },
    "call": {
      "not_found": "No such call",
      "already_handled": "Somebody has already taken that call back",
      "not_an_order": "Take the order first — there is nothing yet for the caller to wait for.",
      "not_connected": "That caller is not talking to anybody right now.",
      "not_on_hold": "That caller is no longer on hold.",
      "not_ringing": "That call is no longer ringing — somebody answered it, or the caller hung up."
    },
    "driver": {
      "not_found": "No such driver",
      "already_hired": "That person is already a driver at this company."
    },
    "membership": {
      "not_found": "That person is not a member of this company"
    },
    "customer": {
      "not_found": "No such customer",
      "already_linked": "That customer is already linked to an account"
    },
    "order": {
      "not_found": "No such ride",
      "illegal_transition": "That is not possible right now",
      "not_rateable": "Only a finished ride can be rated",
      "pre_bookings_disabled": "This company does not take orders for later.",
      "cancellation_reason_unknown": "That reason is not on the list any more. Choose another.",
      "cancellation_reason_name_taken": "Another reason already has that name."
    },
    "rider": {
      "blocked": "This account cannot book. Please ring the office.",
      "no_phone": "This account has no verified phone number."
    },
    "password": {
      "breached": "That password has appeared in a data breach. Please choose another."
    },
    "shift": {
      "driver_inactive": "This driver is not active",
      "vehicle_inactive": "This vehicle is not active",
      "no_vehicle": "No vehicle has been assigned",
      "driver_document_expired": "A document for this driver has expired",
      "vehicle_document_expired": "A document for this vehicle has expired",
      "driver_document_missing": "A required document for this driver is missing",
      "vehicle_document_missing": "A required document for this vehicle is missing",
      "order_in_progress": "There is a ride in progress",
      "vehicle_not_allowed": "The office has not allowed you car {{plate}}. Choose one of yours, or ask the office.",
      "vehicle_taken": "Another driver has just taken car {{plate}}. Choose another."
    },
    "validation": {
      "coordinates_required": "Pick an address from the list so its location is recorded",
      "invalid_phone_number": "That does not look like a phone number",
      "in_the_future": "That time is in the future",
      "implausible_coordinates": "Those coordinates are not possible",
      "at_least_one_required": "Fill in at least one of these",
      "out_of_range": "That value is out of range",
      "unknown_order_state": "Unknown order state",
      "unknown_shift_state": "Unknown shift state",
      "unknown_no_cars_action": "Unknown action for when no cars are found",
      "unknown_outbound_line_strategy": "Unknown rule for which line calls leave on",
      "unknown_call_flow": "Unknown call flow",
      "unknown_hold_expiry": "Unknown action for when a caller has waited long enough",
      "invalid_format": "That is not written the way this field needs",
      "not_a_url": "That does not look like a web address",
      "required": "This is needed",
      "unknown_payment_method": "Unknown way of paying",
      "unknown_day_of_week": "Unknown day of the week",
      "invalid_slug": "A company code must be lowercase letters, digits and hyphens, starting with a letter",
      "reserved_slug": "That name belongs to the platform itself — choose another code",
      "unknown_culture": "Unknown language and region",
      "unknown_time_zone": "Unknown time zone",
      "unknown_currency": "Unknown currency",
      "invalid_calling_code": "A calling code is one to four digits, without the plus",
      "not_a_colour": "A colour looks like #RRGGBB",
      "unknown_document_owner": "A document belongs to a driver or to a vehicle.",
      "unknown_document_kind": "That is not a kind of document this system records.",
      "unknown_phone_line_kind": "A line is a booking line, a mobile, an office line, WhatsApp or Viber",
      "one_support_line": "Only one line can be the one the apps dial",
      "invalid_line_name": "A line’s name is lowercase letters, digits, hyphens and underscores, starting with a letter — the name the PBX knows it by",
      "already_listed": "That is already in the list",
      "set_on_the_pbx": "This line is set up in the telephone system's own configuration, which holds its password, if it has one",
      "too_long": "That is too long",
      "not_an_address": "That does not look like a network address",
      "unknown_line_kind": "A line is a SIM or a trunk",
      "missing_number": "Missing number",
      "not_a_full_number": "“{{typed}}” is not a full number — write it with the area code, like {{example}}",
      "unknown_line": "That is not one of this company’s lines",
      "zone.circle_incomplete": "Click the map to place the circle's centre",
      "zone.polygon_incomplete": "Click the map to draw at least three corners",
      "zone.cycle": "A zone cannot sit inside itself",
      "zone.too_deep": "Zones nest three levels deep at most; this parent is already at the bottom",
      "zone.has_children": "Remove or move the zones inside this one first",
      "surcharge.no_effect": "Give the rate a percentage or an amount; at zero it would change nothing",
      "unknown_surcharge_kind": "A rule applies at certain hours or on holidays",
      "unknown_surcharge_mode": "A rule has prices of its own or an uplift",
      "not_a_host_name": "That is not a web address: letters, digits and hyphens, separated by dots",
      "reserved_host": "That address belongs to the platform itself — choose another",
      "too_many": "Too many at once — choose fewer"
    },
    "request": {
      "failed": "The request could not be completed",
      "malformed": "The request could not be read",
      "rate_limited": "Too many requests. Wait a moment and try again."
    },
    "server": {
      "unexpected": "Something went wrong. Please try again."
    },
    "unknown": "Something went wrong",
    "billing": {
      "no_duty_rate": "This company has not set what a day costs yet.",
      "payment_already_reversed": "That payment has already been reversed",
      "payment_is_a_reversal": "A reversal cannot itself be reversed. Record a new payment instead."
    },
    "duty_rate": {
      "not_found": "No such rate"
    },
    "driver_payment": {
      "not_found": "No such payment"
    },
    "duty": {
      "not_shared": "This company settles up in the office rather than in the app."
    },
    "feature": {
      "not_included": "Your company does not have this feature"
    },
    "branding": {
      "logo_too_large": "That image is too large. A logo may be at most 512 KB.",
      "logo_not_an_image": "That file is not a PNG, JPEG or WebP image."
    },
    "import": {
      "unknown_format": "That file format is not one this can read",
      "unreadable": "This file is not the format it was uploaded as",
      "not_utf8": "This file is not UTF-8. It looks like {{encoding}} — save it as UTF-8 and try again.",
      "no_phone": "No telephone number",
      "bad_phone": "The telephone number could not be read",
      "withheld_number": "A withheld number, with nobody behind it",
      "bad_coordinates": "Coordinates that are not on the map"
    },
    "invite": {
      "invalid": "That invitation link is not valid.",
      "expired": "That invitation has expired. Ask for another one.",
      "already_accepted": "That invitation has already been used. Sign in instead.",
      "not_found": "There is no invitation to send again.",
      "platform_account": "That address belongs to a platform operator, which cannot join a firm. Ask for the invitation to be sent to another address."
    },
    "vehicle": {
      "not_found": "No such vehicle",
      "plate_taken": "Another vehicle already has that registration.",
      "category_unknown": "This company has no vehicle class called “{{code}}”.",
      "feature_unknown": "This company's cars offer nothing called “{{code}}”.",
      "feature_name_taken": "Another label already has that name.",
      "feature_picture_too_large": "A picture may be at most {{maxBytes}} bytes.",
      "feature_picture_not_an_image": "That file is not a PNG, JPEG or WebP picture."
    },
    "document": {
      "not_found": "No such document"
    },
    "mfa": {
      "challenge_invalid": "That sign-in is no longer waiting. Start again.",
      "challenge_expired": "That sign-in took too long. Start again.",
      "invalid_code": "That code is not right.",
      "too_many_attempts": "Too many codes tried. Start the sign-in again.",
      "already_enrolled": "This account already has an authenticator. Enter a code from it."
    },
    "setup": {
      "step_unknown": "That is not a setup step this company has",
      "step_required": "This step cannot be marked as not needed; the company cannot take a booking without it"
    },
    "message": {
      "disabled": "This company does not exchange messages with drivers in the app.",
      "empty": "Write something, or pick one of the ready phrases.",
      "too_long": "That message is too long.",
      "unknown_code": "That is not one of the ready phrases."
    },
    "alarm": {
      "disabled": "This company's driver app has no alarm.",
      "not_found": "No such alarm"
    },
    "heading_home": {
      "disabled": "This company does not take where its drivers are going.",
      "off_duty": "Start your shift first.",
      "no_saved_home": "Save your home first."
    },
    "rating": {
      "disabled": "This company does not ask drivers to rate passengers."
    },
    "heatmap": {
      "disabled": "This company does not show drivers where the work is."
    },
    "taximeter": {
      "disabled": "This company's driver app runs no taximeter."
    },
    "street_ride": {
      "disabled": "This company does not record passengers taken off the street in the app.",
      "off_duty": "Start your shift first.",
      "offer_open": "Answer the job you have been offered first.",
      "no_position": "The phone has not yet said where it is. Wait a moment and try again."
    },
    "place": {
      "not_found": "That address is not on the firm's list any more",
      "duplicate": "{{line}} is already on the firm's list",
      "name_taken": "Another address already goes by “{{name}}”: {{line}}",
      "entrance_invalid": "An entrance is one letter, or a number of one or two digits",
      "entrance_needs_number": "An entrance belongs to a house or block number — add the number to the address",
      "nothing_waiting": "Nothing here is waiting for approval any more",
      "not_allowed": "This company does not allow that",
      "door_not_named": "This ride's address names no entrance to remember",
      "door_not_a_place": "This ride's address is not one of the company's own",
      "door_wrong_moment": "The spot is saved once the passenger is in the car",
      "door_inaccurate": "The phone is not sure enough where it is — try again in a moment",
      "door_too_far": "That is too far from the pickup to be its entrance",
      "google_name_unchanged": "Google named this address. Write it your own way before locking it",
      "google_pin_unmoved": "Google named this address. Move the pin to the exact door before locking it",
      "join_empty": "Nothing was chosen to join.",
      "join_conflict": "This join already belongs to another address.",
      "join_undone": "That join was undone."
    },
    "report": {
      "row_gone": "That row has changed — the list was reloaded."
    },
    "place_change": {
      "not_found": "That version of the address is not in its history"
    },
    "place_report": {
      "not_found": "That report is not waiting any more"
    },
    "place_join": {
      "not_found": "Join not found."
    },
    "geo": {
      "google_not_configured": "This installation has no Google key, so the passenger app cannot search Google."
    },
    "device": {
      "requests_off": "This company does not take service device requests. Ask the office for a QR code.",
      "not_enrolled": "This phone is not registered as a service device.",
      "retired": "The office has written this device off.",
      "request_rejected": "The office turned down the request from this phone.",
      "request_closed": "The request has been answered already, or has lapsed.",
      "in_use_elsewhere": "The account is in use on another phone.",
      "ticket_invalid": "This QR code has been used or has lapsed. Ask the office for a new one.",
      "staff_account": "This person works in the office too. A service device is for a driver only.",
      "rate_limited": "Too many requests. Try again in a little while.",
      "account_inactive": "The office has suspended the account on this phone.",
      "stopped": "This phone no longer carries the account: the office removed it, or the driver is working from another.",
      "identity_invalid": "The phone could not identify itself. Close the app and try again."
    }
  },
  "states": {
    "Requested": "Waiting",
    "Assigned": "Assigned",
    "EnRouteToPickup": "On the way",
    "WaitingForRider": "At pickup",
    "OnBoard": "In progress",
    "Completed": "Completed",
    "Cancelled": "Cancelled",
    "NoShow": "No show"
  },
  "actors": {
    "Rider": "Rider",
    "Driver": "Driver",
    "Dispatcher": "Dispatcher",
    "System": "System"
  },
  "shiftStates": {
    "Available": "Available",
    "Busy": "Busy",
    "OnBreak": "On break",
    "OffDuty": "Off duty"
  },
  "fare": {
    "base": "Starting price",
    "distance": "{{kilometres}} km at {{rate}}",
    "time": "{{minutes}} min at {{rate}}",
    "waiting": "{{minutes}} min waiting at {{rate}} (first {{free}} free)",
    "surcharge": "{{name}}",
    "minimum": "Minimum fare {{minimum}}",
    "rounding": "Rounding",
    "cancellation": "Cancellation fee",
    "no_show": "No-show fee"
  },
  "vehicles": {
    "classLabel": "Class",
    "featuresLabel": "Requirements",
    "anyClass": "Any class",
    "class": {
      "standard": "Standard",
      "estate": "Estate",
      "van": "Van"
    },
    "feature": {
      "suitcases": "Suitcases",
      "small_pet": "Small pet, up to 5 kg",
      "big_pet": "Big pet, over 5 kg",
      "card_payment": "Pay by card",
      "baby_stroller": "Baby stroller",
      "wheelchair": "Wheelchair"
    },
    "featureShort": {
      "suitcases": "Suitcases",
      "small_pet": "Small pet",
      "big_pet": "Big pet",
      "card_payment": "Card",
      "baby_stroller": "Stroller",
      "wheelchair": "Wheelchair"
    }
  },
  "driverMessages": {
    "driver": {
      "on_my_way": "On my way",
      "running_late": "Running late",
      "passenger_not_here": "The passenger is not here",
      "call_me": "Please call me",
      "break_ten": "Taking ten minutes",
      "car_problem": "Problem with the car",
      "ok": "OK"
    },
    "office": {
      "call_office": "Please call the office",
      "wait_there": "Please wait there",
      "passenger_coming": "The passenger is coming out",
      "go_to_rank": "Please go to the rank",
      "hurry": "Please hurry",
      "ok": "OK"
    }
  },
  "cancellationReasons": {
    "changed_mind": "I changed my plans",
    "waited_too_long": "I waited too long",
    "found_other": "I found another way",
    "wrong_address": "I got the address wrong",
    "other": "Something else"
  }
}
